import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { DecisionGuideSection } from '../components/DecisionGuideSection';
import { DeliverySection } from '../components/DeliverySection';
import { ForWhoSection } from '../components/ForWhoSection';
import { FaqSection } from '../components/FaqSection';
import { PricingSection } from '../components/PricingSection';
import { FooterDisclaimer } from '../components/FooterDisclaimer';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden" data-id="element-145">
      <HeroSection data-id="element-146" />
      <ProblemSection data-id="element-147" />
      <SolutionSection data-id="element-148" />
      <MechanismSection data-id="element-149" />
      <WhatYouGetSection data-id="element-150" />
      <DecisionGuideSection data-id="element-151" />
      <DeliverySection data-id="element-152" />
      <ForWhoSection data-id="element-153" />
      <FaqSection data-id="element-154" />
      <PricingSection data-id="element-155" />
      <FooterDisclaimer data-id="element-156" />
    </div>;
}